export function getRiskColor(theftPercent?: number, iconColor?: string, inReaction?: boolean): string {
  if (inReaction || iconColor === 'critical' || (theftPercent != null && theftPercent >= 75)) {
    return '#ef4444';
  }
  return '#3b82f6';
}

export function getRiskAlertColor(level: string): string {
  switch (level.toLowerCase()) {
    case 'critical':
      return '#ef4444';
    case 'alert':
    case 'high':
      return '#f59e0b';
    case 'warning':
    case 'medium':
      return '#fb923c';
    case 'info':
    case 'low':
      return '#3b82f6';
    default:
      return '#94a3b8';
  }
}

export function getClusterColor(_childCount: number, avgRisk: number): string {
  if (avgRisk >= 75) return '#ef4444';
  return '#3b82f6';
}
